var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gameScreen"}},[_c('b-row',[_c('b-col',[_c('b-button',{attrs:{"size":"lg"},on:{"click":function($event){return _vm.addScore(456)}}},[_vm._v("Add score")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }